import { render, staticRenderFns } from "./BnFormField.vue?vue&type=template&id=a3c418d6&scoped=true&"
import script from "./BnFormField.vue?vue&type=script&lang=js&"
export * from "./BnFormField.vue?vue&type=script&lang=js&"
import style0 from "./BnFormField.vue?vue&type=style&index=0&id=a3c418d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c418d6",
  null
  
)

export default component.exports